const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

// 2 standard deviations flags values outside the most typical monthly range.
const ANOMALY_ZSCORE_THRESHOLD = 2;

export const getFarmerCostPerKg = (farmerData, farmer) => {
  const raw =
    farmerData?.CostPerKg ??
    farmerData?.costPerKg ??
    farmer?.costPerKg ??
    farmer?.CostPerKg;
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const buildDailyMilkChartData = (dailyRecords = {}, daysInMonth = 0) => {
  return Array.from({ length: daysInMonth }, (_, i) => {
    const day = i + 1;
    const qty = toNumber(dailyRecords[String(day)]);
    return {
      day,
      qty,
    };
  });
};

export const buildMilkPayoutBreakdown = (calendarTotals, costPerKg) => {
  const unitCost = toNumber(costPerKg);
  const firstHalfMilk = toNumber(calendarTotals?.firstHalf);
  const secondHalfMilk = toNumber(calendarTotals?.secondHalf);
  const monthlyMilk = toNumber(calendarTotals?.monthly);

  return {
    unitCost,
    firstHalfAmount: firstHalfMilk * unitCost,
    secondHalfAmount: secondHalfMilk * unitCost,
    totalAmount: monthlyMilk * unitCost,
  };
};

export const detectMilkRecordAnomalies = (dailyRecords = {}, daysInMonth = 0) => {
  const entries = [];
  for (let day = 1; day <= daysInMonth; day += 1) {
    const value = Number(dailyRecords[String(day)]);
    if (Number.isFinite(value) && value > 0) {
      entries.push({ day, value });
    }
  }

  if (entries.length < 3) {
    return {
      mean: 0,
      stdDev: 0,
      anomalyDays: [],
      anomalyCount: 0,
      sampleSize: entries.length,
    };
  }

  const mean = entries.reduce((sum, entry) => sum + entry.value, 0) / entries.length;
  const variance =
    entries.reduce((sum, entry) => sum + (entry.value - mean) ** 2, 0) / entries.length;
  const stdDev = Math.sqrt(variance);

  if (!stdDev) {
    return {
      mean,
      stdDev,
      anomalyDays: [],
      anomalyCount: 0,
      sampleSize: entries.length,
    };
  }

  const anomalyDays = entries
    .filter(
      (entry) =>
        Math.abs((entry.value - mean) / stdDev) >= ANOMALY_ZSCORE_THRESHOLD
    )
    .map((entry) => entry.day);

  return {
    mean,
    stdDev,
    anomalyDays,
    anomalyCount: anomalyDays.length,
    sampleSize: entries.length,
  };
};
